import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const done = useRef(false);
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/session", { session_id: sid })
      .then(async () => { await refresh(); nav("/dashboard", { replace: true }); })
      .catch((e) => setError(errMsg(e)));
  }, [nav, refresh]);

  if (!error) return null;
  return (
    <div className="min-h-screen grid place-items-center bg-[#FAFAF7] p-6">
      <div className="max-w-md text-center" data-testid="auth-error">
        <p className="font-serif-display text-2xl text-amber-950">We could not sign you in</p>
        <p className="mt-2 text-sm text-stone-600">{error}</p>
        <a href="/" className="mt-6 inline-block text-sm font-semibold text-amber-900 underline">Return to the sign-in page</a>
      </div>
    </div>
  );
}
